<template>
  <b-card no-body class="mt-2">
    <section class="whatsapp-logs p-3">
      <section class="header d-flex align-items-center justify-content-between">
        <section>
          <p class="m-0 title">
            Logs de envio das mensagens de WhatsApp.
          </p>
        </section>

        <section>
          <button
            class="btn-back p-1 px-3"
            @click="goBack()"
          >
            <b-icon icon="arrow-left"></b-icon>
            <span class="ml-2">Voltar</span>
          </button>
        </section>
      </section>
      <hr />

      <b-container fluid align="center">
        <b-row cols="12">
          <b-col class="m-0 p-0 pr-1 py-1" sm="12" md="12" lg="4" xl="4">
            <b-form-input
              v-model="logsMeta.phone"
              placeholder="Filtrar por telefone"
              debounce="500"
              @update="resetPageAndList()"
            ></b-form-input>
          </b-col>

          <b-col class="m-0 p-0 px-1 py-1" sm="12" md="12" lg="3" xl="3">
            <b-form-select
              v-model="logsMeta.status"
              :options="statusOptions"
              @change="resetPageAndList()"
            >
              <template #first>
                <b-form-select-option :value="null">Todos os status</b-form-select-option>
              </template>
            </b-form-select>
          </b-col>

          <b-col class="m-0 p-0 px-1 py-1" sm="12" md="12" lg="3" xl="3">
            <b-form-select
              v-model="logsMeta.triggerTag"
              :options="tagsWhatsAppMessage"
              value-field="tag"
              text-field="tagDescription"
              @change="resetPageAndList()"
            >
              <template #first>
                <b-form-select-option :value="null">Todas as tags</b-form-select-option>
              </template>
            </b-form-select>
          </b-col>

          <b-col class="m-0 p-0 pl-1 py-1" sm="12" md="12" lg="2" xl="2">
            <b-button
              variant="success"
              class="w-100 d-flex align-items-center justify-content-center"
              @click="resetFilters()"
            >
              <b-icon icon="arrow-repeat"></b-icon>
              <strong class="ml-2">Limpar filtros</strong>
            </b-button>
          </b-col>
        </b-row>
      </b-container>

      <section class="d-flex flex-wrap align-items-center mt-3">
        <span class="summary-total mr-3">
          Total de registros: <strong>{{ summary.total }}</strong>
        </span>
        <b-badge variant="success" class="summary-badge mr-2">
          Enviados: {{ summary.sent }}
        </b-badge>
        <b-badge variant="danger" class="summary-badge">
          Falhas: {{ summary.failed }}
        </b-badge>
      </section>

      <section class="mt-3">
        <b-overlay
          :show="loading"
          rounded
          opacity="0.6"
          spinner-small
          spinner-variant="primary"
          class="d-inline-block w-100"
          style="min-height: 100px"
        >
          <table class="w-100 text-center">
            <thead>
            <tr class="thead-tr">
              <th class="py-3">Telefone</th>
              <th class="py-3">Tag de gatilho</th>
              <th class="py-3">Template</th>
              <th class="py-3">Status</th>
              <th class="py-3">Detalhe</th>
              <th class="py-3">Data</th>
            </tr>
            </thead>
            <tbody>
            <tr
              v-for="(log, index) in logs"
              :key="`${log._id}_${index}`"
              class="tbody-tr"
              :style="index < logs.length - 1 ? 'border-bottom: 1px solid #EDEDED;' : ''"
            >
              <td class="px-1 py-2">{{ log.phone }}</td>
              <td class="px-1 py-2">
                {{
                  log.triggerTag
                    ? tagLabel(log.triggerTag)
                    : 'Nenhuma tag vinculada'
                }}
              </td>
              <td class="px-1 py-2">{{ log.templateName || '-' }}</td>
              <td class="px-1 py-2">
                <span :class="statusClass(log.status)">
                  {{ statusLabel(log.status) }}
                </span>
              </td>
              <td class="px-1 py-2">{{ log.error || '-' }}</td>
              <td class="px-1 py-2">{{ formatDate(log.sentAt || log.createdAt) }}</td>
            </tr>
            <tr v-if="hasError && !loading">
              <td colspan="6" class="text-center">
                <p class="py-2 pt-4 text-danger"><strong>
                  Não foi possível carregar os logs de envio. Tente novamente.
                </strong></p>
              </td>
            </tr>
            <tr v-else-if="(!logs || logs.length === 0) && !loading">
              <td colspan="6" class="text-center">
                <p class="py-2 pt-4"><strong>
                  Nenhum log de envio encontrado. Tente ajustar os filtros.
                </strong></p>
              </td>
            </tr>
            </tbody>
          </table>
          <template v-slot:overlay>
            <div class="text-center loading-spinner">
              <b-spinner
                style="width: 3rem; height: 3rem"
                variant="primary"
                label="Large Spinner"
              ></b-spinner>
              <h5 class="text-primary">Buscando...</h5>
            </div>
          </template>

          <section>
            <b-pagination
              v-if="logsMeta.total > logsMeta.limit"
              align="center"
              :per-page="logsMeta.limit"
              v-model="logsMeta.page"
              :total-rows="logsMeta.total"
              first-text="⏮"
              prev-text="⏪"
              next-text="⏩"
              last-text="⏭"
              @page-click="setPage"
              size="lg"
              class="mt-3"
            >
            </b-pagination>
          </section>
        </b-overlay>
      </section>
    </section>
  </b-card>
</template>
<script>
import { mapActions } from 'vuex'
import format from 'date-fns/esm/format/index'

export default {
  name: 'WhatsAppMessageLogs',
  data() {
    return {
      loading: false,
      hasError: false,
      tagsWhatsAppMessage: [],
      logs: [],
      summary: {
        total: 0,
        sent: 0,
        failed: 0
      },
      statusOptions: [
        { value: 'sent', text: 'Enviado' },
        { value: 'failed', text: 'Falha' }
      ],
      logsMeta: {
        page: 1,
        limit: 10,
        total: 0,
        phone: null,
        status: null,
        triggerTag: null,
        whatsAppMessage: null
      }
    }
  },
  async mounted() {
    const { items } = await this.handleTagsInstructionalVideos()
    this.tagsWhatsAppMessage = (items || []).map((x) => {
      return {
        ...x,
        tagDescription: `${x.description} (${x.tag})`
      }
    })
    this.logsMeta.whatsAppMessage = this.$route.query.whatsAppMessage || null
    await this.pagedList()
  },
  methods: {
    ...mapActions('whatsAppMessage', {
      handleLogsPagedList: 'handleLogsPagedList',
      handleLogsSummary: 'handleLogsSummary'
    }),
    ...mapActions('tags', {
      handleTagsInstructionalVideos: 'handleTagsInstructionalVideos'
    }),
    formatDate(date) {
      if (!date) {
        return '-'
      }
      return format(new Date(date), 'dd/MM/yyyy HH:mm:ss')
    },

    tagLabel(triggerTag) {
      const tag = this.tagsWhatsAppMessage.find((x) => x.tag === triggerTag)
      return tag ? tag.tagDescription : triggerTag
    },

    statusLabel(status) {
      if (status === 'failed') {
        return 'Falha'
      }
      if (status === 'pending') {
        return 'Pendente'
      }
      return 'Enviado'
    },

    statusClass(status) {
      if (status === 'failed') {
        return 'text-danger'
      }
      if (status === 'pending') {
        return 'text-muted'
      }
      return 'text-success'
    },

    goBack() {
      this.$router.back()
    },

    notifyLoadError() {
      this.$bvToast.toast('Não foi possível carregar os logs de envio. Tente novamente.', {
        title: 'Atenção',
        variant: 'danger',
        toaster: 'b-toaster-top-center',
        autoHideDelay: 5000
      })
    },

    async setPage(event, page) {
      this.logsMeta.page = page
      await this.pagedList()
    },

    async resetPageAndList() {
      this.logsMeta.page = 1
      await this.pagedList()
    },

    async pagedList() {
      try {
        this.loading = true
        this.hasError = false
        const result = await this.handleLogsPagedList(this.logsMeta)
        if (result) {
          this.logs = result.items
          this.logsMeta = result.meta
          await this.fetchSummary()
        } else {
          this.hasError = true
          this.logs = []
          this.notifyLoadError()
        }
        this.loading = false
      } catch (e) {
        this.hasError = true
        this.loading = false
        this.notifyLoadError()
      }
    },

    async fetchSummary() {
      const summary = await this.handleLogsSummary(this.logsMeta)
      if (summary) {
        this.summary = {
          total: summary.total || 0,
          sent: summary.sent || 0,
          failed: summary.failed || 0
        }
      }
    },

    async resetFilters() {
      this.logsMeta = {
        page: 1,
        limit: 10,
        total: 0,
        phone: null,
        status: null,
        triggerTag: null,
        whatsAppMessage: null
      }
      await this.pagedList()
    }
  }
}
</script>
<style lang="scss" scoped>
.whatsapp-logs {
  .header {
    .title {
      font-weight: 700;
      font-size: 16px;
      line-height: 24px;
      color: #262626;
    }

    .btn-back {
      font-weight: 400;
      font-size: 15px;
      border: 1px solid #AEBBCD;
      border-radius: 6px;
      color: #6D7989;
      background: #FFFFFF;
    }
  }

  .thead-tr {
    background: var(--navy-blue);
    color: #ECF0F3;
    font-weight: 600;
    font-size: 16px;
    text-align: center;
  }

  .tbody-tr {
    background: #FFFFFF;
    font-size: 15px;
    text-align: center;
    color: #808080;
    font-weight: 400;
  }

  .summary-total {
    font-size: 15px;
    color: #262626;
  }

  .summary-badge {
    font-size: 13px;
    padding: 6px 10px;
  }
}
</style>
